import React from "react";
import { Col, FloatingLabel, Form, FormControl, Row } from "react-bootstrap";

/**
 * 
 * @param {param} data object of data passed from main container
 * @param {param} setData setter for object data
 * @param {param} errors object of errors passed from main container
 * @param {param} setErrors setter for object errors
 * 
 * @returns fields 
 */
const AnlageUseStage = ({data, setData, errors, setErrors}) => {

    return (
        <>
            <Row>
                <Col xl="8">
                    <FloatingLabel label="Straße">
                        <FormControl
                            isValid={data.street !== ""}
                            isInvalid={errors.street === true}
                            placeholder="Straße" 
                            value={data.street} 
                            onChange={e => { setData((prev) => ({...prev, street: e.target.value})); setErrors({})}}
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="4">
                    <FloatingLabel label="Hausnummer">
                        <FormControl
                            isValid={data.houseNumber !== ""}
                            isInvalid={errors.houseNumber === true}
                            placeholder="Hausnummer" 
                            value={data.houseNumber} 
                            onChange={e => { setData((prev) => ({...prev, houseNumber: e.target.value})); setErrors({})}} />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xl="4">
                    <FloatingLabel label="Anlagenverwendung">
                        <Form.Select
                            isValid={data.anlageUse !== ""}
                            isInvalid={errors.anlageUse === true}
                            onChange={e => { setData((prev) => ({...prev, anlageUse: e.target.value})); setErrors({}); e.target.value === "Allgemeine Liegenschaftsteile"? setData((prev) => ({...prev, asLeerstand: false})) : setData((prev) => ({...prev, asLeerstand: true})) }}>
                            <option value="">Anlagenverwendung auswählen</option>
                            <option value="Allgemeine Liegenschaftsteile">Allgemeine Liegenschaftsteile</option>
                            <option value="Wohnung">Wohnung</option>
                            <option value="Gewerbe">Gewerbe</option>
                        </Form.Select>
                    </FloatingLabel>
                </Col>
                <Col xl="8" hidden={data.anlageUse !== "Allgemeine Liegenschaftsteile"}>
                    <FloatingLabel label="Spezifische Anlagenverwendung (zb. Liftstrom, Beleuchtung H12, o.Ä.)">
                        <FormControl
                            isValid={data.anlageUseDesc !== ""}
                            isInvalid={errors.anlageUseDesc === true}
                            value={data.anlageUseDesc}
                            onChange={e => { setData((prev) => ({...prev, anlageUseDesc: e.target.value})); setErrors({})}}
                            placeholder="Spezifische Anlagenverwendung (zb. Liftstrom, Beleuchtung H12, o.Ä.)"
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="2" hidden={data.anlageUse === "Allgemeine Liegenschaftsteile" || data.anlageUse === ""}>
                    <FloatingLabel label="Stiege/Stockwerk">
                        <FormControl 
                            placeholder="Stiege" 
                            value={data.staircase} 
                            onChange={e => setData((prev) => ({...prev, staircase: e.target.value}))} />
                    </FloatingLabel>
                </Col>
                <Col xl="2" hidden={data.anlageUse === "Allgemeine Liegenschaftsteile" || data.anlageUse === ""}>
                    <FloatingLabel label="Top">
                        <FormControl
                            isValid={data.top !== ""}
                            isInvalid={errors.top === true}
                            value={data.top}
                            onChange={e => {setData((prev) => ({...prev, top: e.target.value})); setErrors({}) }}
                            placeholder="Top"
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="4" hidden={data.anlageUse === "Allgemeine Liegenschaftsteile" || data.anlageUse === ""}>
                    <FloatingLabel label="Bestandseinheitennummer">
                        <FormControl
                            isValid={data.bestand !== ""}
                            isInvalid={errors.bestand === true}
                            value={data.bestand}
                            onChange={e => setData((prev) => ({...prev, bestand: e.target.value}))}
                            placeholder="Bestandseinheitennummer"
                        />
                    </FloatingLabel>
                </Col>
            </Row>
        </>
    )
}

export default AnlageUseStage;